import { atom, atomFamily } from 'recoil'

import { PLAN_TYPE } from '../config/consts'

// AtomFamily
export const StringAtom = atomFamily<string, string>({
  key: 'StringAtom',
  default: '',
})

export const NumberAtom = atomFamily<number, string>({
  key: 'NumberAtom',
  default: 0,
})

export const PagingAtom = atomFamily<number, string>({
  key: 'PagingAtom',
  default: 1,
})

export const BooleanAtom = atomFamily<boolean, string>({
  key: 'BooleanAtom',
  default: false,
})

export const SegmentControlAtom = atomFamily<string, string>({
  key: 'segmentControlAtom',
  default: '',
})

export interface TableOption {
  current: number
  sortTarget: number | null
  isAsc: boolean
}

export const TableAtom = atomFamily<TableOption, string>({
  key: 'TableAtom',
  default: {
    current: 1,
    sortTarget: null,
    isAsc: false,
  },
})

// LoginToken
export interface LoginToken {
  accessToken: string
}

export const LoginTokenAtom = atom<LoginToken>({
  key: 'LoginTokenAtom',
  default: {
    accessToken: '',
  },
})

// Service
export interface Service {
  label: string
  planType: number
  value: string
}

export const ServiceAtom = atom<Service>({
  key: 'ServiceAtom',
  default: {
    label: '',
    planType: PLAN_TYPE.LJSDK_SUMMARY,
    value: '',
  },
})

export const ActiveTabKeyAtom = atom<string | null>({
  key: 'ActiveTabKeyAtom',
  default: 'info'
})